/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import CustomCheckBox from "src/shared/CustomCheckBox";
import { useFormik } from "formik";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function Proposer() {
  const generalDetails = useAppSelector((state) => state.proposerDetails.general);
  const addressDetails = useAppSelector((state) => state.proposerDetails.address);
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const proposerDetailsMefFields = mefSchema?.lifeAssuredDetails || {};
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      businessOwner: generalDetails?.businessOwner
    },
    onSubmit: () => {}
  });
  return (
    <div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4 ">
        {(generalDetails?.title || proposerDetailsMefFields?.title?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.title?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.title || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.gender?.visible || generalDetails?.gender) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.gender?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.gender || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.firstName?.visible || generalDetails?.firstName) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.firstName?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.firstName || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.middleName?.visible || generalDetails?.middleName) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.middleName?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.middleName || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.lastName?.visible || generalDetails?.lastName) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.lastName?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.lastName || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.dob?.visible || generalDetails?.dob) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.dob?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.dob || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.maritalStatus?.visible || generalDetails?.maritalStatus) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.maritalStatus?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.maritalStatus || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.nationality?.visible || generalDetails?.nationality) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.nationality?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.nationality || "-"}</CustomReviewField>
          </div>
        )}
        {generalDetails?.nationality !== "Indian" && (
          <>
            {(proposerDetailsMefFields?.countryOfResidence?.visible ||
              generalDetails?.countryOfResidence) && (
              <div className="col-span-1">
                <CustomLabel>{proposerDetailsMefFields?.countryOfResidence?.label}</CustomLabel>
                <CustomReviewField>{generalDetails?.countryOfResidence || "-"}</CustomReviewField>
              </div>
            )}

            {(proposerDetailsMefFields?.cityOfResidence?.visible ||
              generalDetails?.cityOfResidence) && (
              <div className="col-span-1">
                <CustomLabel>{proposerDetailsMefFields?.cityOfResidence?.label}</CustomLabel>
                <CustomReviewField>{generalDetails?.cityOfResidence || "-"}</CustomReviewField>
              </div>
            )}
            {(proposerDetailsMefFields?.lastEntryToIndiaDate?.visible ||
              generalDetails?.dateOfLastEntry) && (
              <div className="col-span-1">
                <CustomLabel>{proposerDetailsMefFields?.lastEntryToIndiaDate?.label}</CustomLabel>
                <CustomReviewField>{generalDetails?.dateOfLastEntry || "-"}</CustomReviewField>
              </div>
            )}
          </>
        )}
        {(proposerDetailsMefFields?.education?.visible ||
          generalDetails?.educationQualification) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.education?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.educationQualification || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.address?.line1?.visible ||
          addressDetails?.address?.address1) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.line1?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.address1 || "-"}</CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.address?.line2?.visible ||
          addressDetails?.address?.address2) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.line2?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.address2 || "-"}</CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.address?.line3?.visible ||
          addressDetails?.address?.address3) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.line3?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.address3 || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.address?.pincode?.visible ||
          addressDetails?.address?.pinCode) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.pincode?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.pinCode || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.address?.city?.visible || addressDetails?.address?.city) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.city?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.city || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.address?.state?.visible || addressDetails?.address?.state) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.address?.state?.label}</CustomLabel>
            <CustomReviewField>{addressDetails?.address?.state || "-"}</CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.mobile?.visible || generalDetails?.mobileNo) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.mobile?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.mobileNo || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.telePhoneNo?.visible || generalDetails?.telePhoneNo) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.telePhoneNo?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.telePhoneNo || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.email?.visible || generalDetails?.email) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.email?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.email || "-"}</CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.occupation?.visible || generalDetails?.occupation) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.occupation?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.occupation || "-"}</CustomReviewField>
          </div>
        )}
        {(generalDetails?.occupationCode === "OT" || generalDetails?.occupation === "Others") &&
          (proposerDetailsMefFields?.subOccupation?.visible || generalDetails?.subOccupation) && (
            <div className="col-span-1">
              <CustomLabel>{proposerDetailsMefFields?.subOccupation?.label}</CustomLabel>
              <CustomReviewField>{generalDetails?.subOccupation || "-"}</CustomReviewField>
            </div>
          )}
        {/* {!(
          ["SE", "OT", ""].includes(generalDetails?.occupationCode!) ||
          ["Self Employed", "Others", ""].includes(generalDetails?.occupation!)
        ) && (
          <> */}
        {(proposerDetailsMefFields?.nameOfOrganization?.visible ||
          generalDetails?.nameOfOrganization) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.nameOfOrganization?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.nameOfOrganization || "-"}</CustomReviewField>
          </div>
        )}
        {!(
          ["SE", "OT", ""].includes(generalDetails?.occupationCode!) ||
          ["Self Employed", "Others", ""].includes(generalDetails?.occupation!)
        ) &&
          (proposerDetailsMefFields?.designation?.visible || generalDetails?.designation) && (
            <div className="col-span-1">
              <CustomLabel>{proposerDetailsMefFields?.designation?.label}</CustomLabel>
              <CustomReviewField>{generalDetails?.designation || "-"}</CustomReviewField>
            </div>
          )}
        {(proposerDetailsMefFields?.annualIncome?.visible || generalDetails?.annualIncome) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.annualIncome?.label}</CustomLabel>
            <CustomReviewField>
              {onChangeIndianCurrency(generalDetails?.annualIncome || "-")}
            </CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.panNo?.visible || generalDetails?.panNo) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.panNo?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.panNo || "-"}</CustomReviewField>
          </div>
        )}

        {(proposerDetailsMefFields?.natureOfWork?.visible || generalDetails?.natureOfWork) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.natureOfWork?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.natureOfWork || "-"}</CustomReviewField>
          </div>
        )}
        {proposerDetailsMefFields?.relationshipWithLifeAssured?.visible && (
          <div className="col-span-1">
            <CustomLabel>
              {proposerDetailsMefFields?.relationshipWithLifeAssured?.label}
            </CustomLabel>
            <CustomReviewField>Self</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.UIDNo?.visible || generalDetails?.UIDNo) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.UIDNo?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.UIDNo || "-"}</CustomReviewField>
          </div>
        )}
        {(proposerDetailsMefFields?.electronicAccount?.visible ||
          generalDetails?.electronicAccount) && (
          <div className="col-span-1">
            <CustomLabel>{proposerDetailsMefFields?.electronicAccount?.label}</CustomLabel>
            <CustomReviewField>{generalDetails?.electronicAccount || "-"}</CustomReviewField>
          </div>
        )}
        {generalDetails?.electronicAccount.toLowerCase() === "yes" &&
          (proposerDetailsMefFields?.eiaNumber?.visible || generalDetails?.eiaNumber) && (
            <div className="col-span-1">
              <CustomLabel>{proposerDetailsMefFields?.eiaNumber?.label}</CustomLabel>
              <CustomReviewField>{generalDetails?.eiaNumber || "-"}</CustomReviewField>
            </div>
          )}

        {proposerDetailsMefFields?.businessOwner?.visible && (
          <div className="col-span-1">
            <CustomCheckBox
              isReview
              label={proposerDetailsMefFields?.businessOwner?.label}
              name="businessOwner"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.businessOwner}
            />
          </div>
        )}
      </div>
    </div>
  );
}
export default Proposer;
